/** Максимальный `limit` для GET /requisites (ограничение бэкенда). */
export const REQUISITES_MAX_LIMIT = 100;

export interface GetRequisitesParams {
  name_or_number?: string | null;
  trader_id?: string | null;
  payment_system_id?: string | null;
  is_active?: boolean | null;
  is_blocked_by_trader?: boolean | null;
  include_pre_deleted?: boolean;
  sort_by?: 'name' | 'transaction_limit';
  sort_order?: 'asc' | 'desc';
  skip?: number;
  limit?: number;
}

export interface PaginatedRequisitesResponse {
  items: Requisite[];
  total: number;
  limit: number;
  skip: number;
  total_pages: number;
}

export interface Requisite {
  has_qr?: boolean;
  id: string;
  name: string;
  trader_id: string;
  payment_system_id: string;
  number: string;
  second_number?: string;
  holder_name: string;
  bank_id: string;
  min_transaction_limit: number;
  max_transaction_limit: number;
  counter_limit: number;
  amount_limit: number;
  current_counter: number;
  current_amount: number;
  pending_amount: number;
  pending_counter: number;
  is_active: boolean;
  is_blocked_by_trader: boolean;
  pre_deled: boolean;
  created_at: string;
  updated_at: string;
}

export interface RequisiteFormData {
  name: string;
  trader_id: string;
  payment_system_id: string;
  currency_id: number;
  number: string;
  second_number?: string;
  holder_name: string;
  bank_id: string;
  min_transaction_limit: number;
  max_transaction_limit: number;
  counter_limit: number;
  amount_limit: number;
  current_counter: number;
  current_amount: number;
  pending_amount: number;
  pending_counter: number;
  is_active: boolean;
  pre_deled: boolean;
}

export interface RequisiteBlock {
  id: string;
  requisite_id: string;
  trader_id: string;
  trader: string;
  amount: number;
  transaction_id?: string;
  trader_invoice_id?: string;
  date_create: string;
  is_active: boolean;
}
